import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {ValidOre, mapValidOreToJson, ValVersOreDTOApiResponse, mapJsonToValVersOreDTOApiResponse} from "./types";
import {columnFiltersParamWithDateRange, sortingParam} from "../../common/Services";


const moment = require('moment')

export function useGetValVersOreDTO(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
    enabled: boolean = true // for wait of tab settings
 ) {
    return useQuery<ValVersOreDTOApiResponse>({
        queryKey: [
            'fetchValVersOreDTO',
            columnFilters, // refetch when columnFilters changes
            globalFilter,  // refetch when globalFilter changes
            pagination.pageIndex, // refetch when pagination.pageIndex changes
            pagination.pageSize, // refetch when pagination.pageSize changes
            sorting, // refetch when sorting changes
            enabled, // for wait of tab settings
        ],
        queryFn: async () => {

            //
            // let coddip = localStorage.getItem('coddip') || 'NN';
            // let impcoddip = localStorage.getItem('impcoddip') || 'NN';
            //
            // const role = localStorage.getItem('keyrole') || '';
            //

            let coddip = localStorage.getItem('coddip') || '';
            const keyrole = localStorage.getItem('keyrole') || '';

            const isAdmin =  (keyrole.includes('TimeReportAdmin')  || keyrole.includes('TimeReportValVersOre')) ;



            // if (role.includes('TimeReportAdmin')) {
            //                     coddip = (impcoddip.trim() === 'NN' || impcoddip.trim() === '') ? '' : impcoddip.trim();
            //                 } else if (role.includes('TimeReportUser')) {
            //                     coddip = localStorage.getItem('coddip') || 'NN';
            //                 } else if (role.includes('TimeReportCust')) {
            //                     coddip = 'NN';
            //                 } else if (role.includes('TimeReportAgent')) {
            //                     coddip = '';
            //                 }

         // if (role.includes('TimeReportAdmin')  || role.includes('TimeReportValVersOre')) {
         //                        coddip = (impcoddip.trim() === 'NN' || impcoddip.trim() === '') ? '' : impcoddip.trim();
         //                    } else if (role.includes('TimeReportUser')) {
         //                        coddip = localStorage.getItem('coddip') || 'NN';
         //                    } else if (role.includes('TimeReportCust')) {
         //                        coddip = 'NN';
         //                    } else if (role.includes('TimeReportAgent')) {
         //                        coddip = '';
         //                    }





            // console.log('role:', role);
            // console.log('impcoddip:', impcoddip);
            // console.log('coddip',coddip);

            const myLimit=pagination.pageSize
            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;

            let myURL = `?limit=${myLimit}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange(
                columnFilters,
                'VBT80'
            )}&ordering=${sortingParam(sorting, 'VBT80')}`;


            if (!isAdmin) {
                        myURL += `&VBT80_REF=${coddip}&VBT80_EMAILCLIENTETIMEREPORT__isnull=false&VBT80_FLGVAL=N`;
                }

            if (isAdmin) {
                        myURL += `&VBT80_EMAILCLIENTETIMEREPORT__isnull=false`;
                }


            const response = await AxiosInstance.get(`valversoredto/${myURL}`);

            return mapJsonToValVersOreDTOApiResponse(response.data);
        },
        refetchOnWindowFocus: false,
    });
}


export function useCreateValidOre() {
  const queryClient = useQueryClient();
  return useMutation({

    mutationFn: async (validOre: ValidOre) => {
    // console.log("prevSE", prevSE)
      return AxiosInstance.post('validore/0/',mapValidOreToJson(validOre));
    },
      // onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fetchVersOre'] }), //refetch  after mutation, disabled for demo
     });
}


export function useDeleteValidOre() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (nrrel: number) => {
         return AxiosInstance.delete('validore/'+nrrel);
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['fetchVersOre'] }), //refetch  after mutation, disabled for demo
  });
}


